import React, { Component } from 'react'
import Header from '../../components/header/Header'
import StagesManager from '../../components/StagesManager'
import BookingUserForm from './booking/components/BookingUserForm'
import { checkDefaultTab, checkTranslation, translate } from '../../utils/useful'
import BookingUserViewServices from './booking/components/BookingUserViewServices'
import BookingReservation from './booking/components/BookingReservation'
import LinearProgressBar from '../../components/progressBars/LinearProgressBar'
import BookingSuccess from './BookingSuccess'
import BookingPreviusInteractions from './BookingPreviusInteractions'
import BookingUserToolbar from '../../components/header/BookingUserToolbar'
import { BookingUserPages } from '../../variables/AppletPages'

export default class BookingUserView extends Component {
    state = {
        stage: 0,
        bg: 'linear-gradient(120deg, rgba(158,0,255,1) 0%, rgba(119,20,97,1) 100%)',
        bg2: 'rgba(37, 91, 0, 0.1)',
        showBackBtn: false,
        showProgressBar: true,
        showToolbar: false,
        currentBooking: {},
        // tabs: [
        //     { name: '{{lang}}Booking Main', key: 'bookingpage' },
        //     { name: '{{lang}}Previous Interactions', key: 'previous' },
        // ],
        modules: [],
        data: {},
        progress: [
            { fistIcon: '/assets/icons/booking/services-white.svg', firtstep: 'Services', color1: '#E9E1EF', color2: '#956DB5' },
            { fistIcon: '/assets/icons/booking/calendar-white.svg', firtstep: 'Date', color1: '#E9E1EF', color2: '#956DB5' },
            { fistIcon: '/assets/icons/booking/provider-white.svg', firtstep: 'Provider', color1: '#E9E1EF', color2: '#956DB5' },
            { fistIcon: '/assets/icons/booking/clock-white.svg', firtstep: 'Time', color1: '#E9E1EF', color2: '#956DB5' },
            { fistIcon: '/assets/icons/booking/form-white.svg', firtstep: 'Form', color1: '#E9E1EF', color2: '#956DB5' },
        ],

        currentPage: 'bookingpage',
    }


    componentDidMount() {
        this.setHeader({
            'toolbar': this.toolbarView,
            'showToolbar': true,
        })

        let accessPages = Object.values(BookingUserPages.pages)
        let accessSections = Object.values(BookingUserPages.sections)

        this.setState({ modules: accessPages, sections: accessSections }, () => {
            this.checkDefaultTab()
        })

    }


    componentDidUpdate(prevProps) {

        if ((this.state.oldData && JSON.stringify(this.state.oldData) != JSON.stringify(this.props.windowData))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        console.log("checkDefaultTab")
        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {

            def = def ?? ''
            pageType = pageType != null ? pageType : def

            console.log("pageType",pageType)

            if (pageType != null) {

                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType, page: null }, () => {

                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
                            if (this.stageManager) {
                                this.stageManager.changeStage((pageType), () => {
                                })
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }

        })
    }



    toolbarView = () => {
        return (
            <BookingUserToolbar functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.headers} />
        )
    }


    toolbarFunctionsHandler = (type, name, data) => {

        console.log("toolbarFunctionsHandler")
        console.log(name)

        if (this[name]) {
            this[name](data)
        }
    }


    changeStage = (key) => {

        console.log(this.stageManager)

        if (this.stageManager) {
            this.stageManager.changeStage(key)
        }
    }

    changeTab = (prop) => {

        this.setState({ currentPage: prop.key })
        this.stageManager.changeStage(prop.key)

    }

    bookingService = (item, index) => {
        this.setDataService('currentBooking', item)
    }

    setDataService = (key, value) => {
        this.setState({ [key]: value }, () => {
        })
    }

    backStage = () => {


        this.stageManager.lastStage((stage) => {

            let showToolbar = false
            let shouldHaveToolbar = ['bookingpage', 0, 'previous', 1]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }


            let showBackBtn = true
            let shouldHaveBackBtn = ['bookingpage', 0, 'previous', 1]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }


            this.setState({ showToolbar, showBackBtn, stage })

        })
    }

    // changePage = (key, stage) => {


    //     let showToolbar = false
    //     let shouldHaveToolbar = ['bookingpage', 'previous']
    //     if (shouldHaveToolbar.includes(stage)) {
    //         showToolbar = true
    //     }


    //     let showBackBtn = true
    //     let shouldHaveBackBtn = ['bookingpage', 'previous']
    //     if (shouldHaveBackBtn.includes(stage)) {
    //         showBackBtn = false
    //     }


    //     this.stagesManager.changeStage(key)
    //     this.setState({ showToolbar, showBackBtn, stage })


    // }


    changePage = (page) => {

        let fullPath = [...this.props.baseUrl, (page?.key ?? page)]

        console.log(fullPath)
        this.changeWindow(fullPath)

    }


    changeWindow = (list) => {
        if (Array.isArray(list)) {

            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });

            this.props.changeWindow('applet', { type: 'applet', path: finalList })
        }
    }




    setData = (data, cb) => {
        let newDate = this.state.data
        if (!newDate) {
            newDate = {}
        }

        if (data == null) {
            newDate = null
        } else {
            for (const [key, value] of Object.entries(data)) {
                newDate[key] = value
            }
        }
        this.setState({ data: newDate }, () => {
            if (cb) { cb() }
        })
    }


    setHeader = (key, value) => {

        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: false
                }

                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }

                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }


                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    render() {
        return (
            <div className='d-flex flex-column w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>

                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >

                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} cart={this.state.cart} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />
                    </div>

                    {/* {!this.state.showBackBtn && (
                        <div className='w-100' style={{ backgroundColor: '#f6f6f6' }}>
                            <div className='flexcc w-100 tab-booking-btn '>
                                {this.state.tabs.map((prop, index) => {
                                    return (
                                        <button key={index} className={'flexcc w-100 py-2  ' + (this.state.currentPage == prop.key ? '  selected ' : ' unselected ')} onClick={() => this.changeTab(prop)}>
                                            <img className='mrd-2' src="" />
                                            <p className='prd-3 font-size-14'>{checkTranslation(prop.name)}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )} */}
                    {/* {this.state.currentPage != 'previous' && (
                        <LinearProgressBar progress={this.state.progress} />
                    )} */}

                    <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true}>
                        <BookingUserViewServices stageName={""} baseUrl={this.props.baseUrl} setData={this.setData} colors={this.props.colors} bookingService={this.bookingService} changeStage={this.changeStage} changeWindow={this.changeWindow} changePage={this.changePage} variables={this.props.variables} stage={0} applet={this.props.applet} pages={this.state.pages} width={this.props.width} pageType={this.state.pageType} user={this.props.user} modules={this.state.modules} route={this.props.route} />
                        <BookingPreviusInteractions stageName={'previous'} setData={this.setData} colors={this.props.colors} bookingService={this.bookingService} changeStage={this.changeStage} variables={this.props.variables} stage={1} applet={this.props.applet} pages={this.state.pages} width={this.props.width} pageType={this.state.pageType} user={this.props.user} modules={this.state.modules} changePage={this.changePage} route={this.props.route} />
                        <BookingReservation stageName={'service'} setData={this.setData} colors={this.props.colors} bookingService={this.bookingService} initData={this.initData} data={this.state.currentBooking} changeStage={this.changeStage} variables={this.props.variables} stage={2} applet={this.props.applet} pages={this.state.pages} width={this.props.width} pageType={this.state.pageType} user={this.props.user} modules={this.state.modules} changePage={this.changePage} route={this.props.route} />
                        <BookingUserForm setData={this.setData} colors={this.props.colors} bookingService={this.bookingService} initData={this.initData} postInformation={this.postInformation} data={this.state.currentBooking} changeStage={this.changeStage} variables={this.props.variables} stage={3} stageName={'form'} applet={this.props.applet} pages={this.state.pages} width={this.props.width} pageType={this.state.pageType} user={this.props.user} modules={this.state.modules} changePage={this.changePage} route={this.props.route} />
                        <BookingSuccess setData={this.setData} colors={this.props.colors} bookingService={this.bookingService} initData={this.initData} postInformation={this.postInformation} data={this.state.currentBooking} changeStage={this.changeStage} variables={this.props.variables} stage={4} stageName={'success'} applet={this.props.applet} pages={this.state.pages} width={this.props.width} pageType={this.state.pageType} user={this.props.user} modules={this.state.modules} changePage={this.changePage} route={this.props.route} />
                    </StagesManager>
                </div>

            </div>
        )
    }
}
